import React from "react";
import QuizItems from "./QuizItems/QuizItems";
import classes from "./QuizPage.module.css";

const QuizPage = (props) => {
  return (
    <div className={classes.QuizPage}>
      <h2 className={classes.QuizPageTitle}>Let's do this!</h2>
      <QuizItems history={props.history} />
    </div>
  );
};

export default QuizPage;
